import { QrCodeState } from './types';

export const state = (): QrCodeState => initialState();

export const initialState = (): QrCodeState => ({
  qrCodes: {
    //TODO remove when was made backend
    items: [],
    isLoading: false,
    total: 2, //TODO remove when was made backend
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['name', 'address'],
    },
  },
});
